import axios from "axios";
import { clearAuth, getToken } from "@/utils/authStorage";

// 创建 axios 实例
// 使用相对路径，通过 vue.config.js 中的代理访问后端
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "",
  timeout: 30000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          clearAuth();
          break;
        case 403:
          console.error("没有权限访问");
          break;
        case 404:
          console.error("请求的资源不存在");
          break;
        case 500:
          console.error("服务器错误");
          break;
        default:
          console.error("请求失败");
      }
    }
    return Promise.reject(error);
  }
);

export default request;
